import axios from "axios";
import { ApiHost } from "../utils/ApiConfig";

const CHAT_MESSAGE_TIMEOUT_MS = 190 * 1000;

export const sendChatMessage = async (
  userInput,
  userSession,
  applicationId,
  accessToken,
) => {
  const response = await axios.post(
    ApiHost + "/chat/message",
    {
      user_input: userInput,
      user_session: userSession,
      application_id: applicationId,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      timeout: CHAT_MESSAGE_TIMEOUT_MS,
    },
  );

  const answer = response.data?.output?.trim();
  if (!answer) {
    throw new Error("Asystent AI nie zwrócił odpowiedzi.");
  }

  return answer;
};

export const saveChatFeedback = async (
  userSession,
  { rating, comment },
  accessToken,
) => {
  const response = await axios.put(
    ApiHost + "/chat/feedback",
    {
      user_session: userSession,
      rating,
      comment,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    },
  );

  return response.data?.feedback;
};

export const endChatConversation = async (userSession, accessToken) => {
  const response = await axios.post(
    ApiHost + "/chat/session/end",
    {
      user_session: userSession,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    },
  );

  return response.data?.ended_at;
};
